import { Routes, Route, Navigate } from 'react-router-dom'
import {
  LoginPage,
  DashBoard,
  TeamSettings,
  DocumentsManagement,
  NoSubscription,
} from '../pages'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<DashBoard />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/no-subscription" element={<NoSubscription />} />
      <Route path="/team-settings" element={<TeamSettings />} />
      <Route path="/documents-management" element={<DocumentsManagement />} />
    </Routes>
  )
}
